export default __webpack_public_path__ + "static/8thWallSocial-6f526d080deac9b0ba24e2d11b7c21d5.png";